<div class="central-header central-header--claims">
  <h3 class="font-normal">{{formatItemDescription(cart_item?.description, 1)}}</h3>
  <div class="dropdown d-none d-md-inline-block">
    <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-none d-md-block"
       data-toggle="dropdown" aria-expanded="false">
      <svg class="icon">
        <use xlink:href="#more"></use>
      </svg>
    </a>
    <a href="#modal-traymenu-actions"
       class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
      <svg class="icon">
        <use xlink:href="#more"></use>
      </svg>
    </a>
    <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
      <a class="dropdown-item" data-sortby="best_value">
        <svg class="icon">
          <use xlink:href="#pause"></use>
        </svg>
        <span>Pause Claim</span>
      </a>
      <a class="dropdown-item" data-sortby="best_value">
        <svg class="icon">
          <use xlink:href="#trash-bin"></use>
        </svg>
        <span>Cancel Claim</span>
      </a>
    </div>
  </div>
</div>


<div class="card card--edit card--claim-details">

  <div class="card-title">
    <h4>Claim Details</h4>
  </div>

  <div class="card-body">
    <a (click)="getDetails()" class="jumbo-button">
      <div class="jumbo-button__left">
        <svg class="icon">
          <use xlink:href="#camera"></use>
        </svg>
        <h5 class="font-16 font-semibold">Damage Report</h5>
      </div>
      <svg class="icon">
        <use xlink:href="#chevron-right-small"></use>
      </svg>
    </a>
  </div>
</div>


